import React from 'react';
import Styles from './index.module.scss';
import ReactDom from 'react-dom';
import {
  CheckOne, CloseOne, Attention, Info,
} from '@icon-park/react';

const id = '_message_contianer_';
let timer: any = null;

function MessageComponent({ type, content }: { type: string; content: string | JSX.Element }) {
  return (
    <div className={`${Styles.container} ${Styles[type]}`}>
      { type === 'success' && <CheckOne theme="filled" fill="#bce2a9" size={18} /> }
      { type === 'error' && <CloseOne theme="filled" fill="#fbb0b0" size={18} /> }
      { type === 'warning' && <Attention theme="filled" fill="#ffd98d" size={18} /> }
      { type === 'info' && <Info theme="filled" fill="#a1caff" size={18} /> }
      {content}
    </div>
  );
}

const Message = {
  success: (content: string | JSX.Element, t = 2000) => {
    const el = createModel('success', content);
    timer = setTimeout(() => {
      ReactDom.render(<div />, el);
    }, t);
  },
  error: (content: string | JSX.Element, t = 2000) => {
    const el = createModel('error', content);
    timer = setTimeout(() => {
      ReactDom.render(<div />, el);
    }, t);
  },
  warning: (content: string | JSX.Element, t = 2000) => {
    const el = createModel('warning', content);
    timer = setTimeout(() => {
      ReactDom.render(<div />, el);
    }, t);
  },
  info: (content: string | JSX.Element, t = 2000) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    timer && clearTimeout(timer);
    const el = createModel('info', content);
    timer = setTimeout(() => {
      ReactDom.render(<div />, el);
    }, t);
  },
};

const createModel = (type: string, content: string | JSX.Element) => {
  let container = document.getElementById(id);
  if (!container) {
    container = document.createElement('div');
    container.id = id;
    document.body.appendChild(container);
  }

  ReactDom.render(<MessageComponent type={type} content={content} />, container);
  return container;
};

export default Message;
